import { render, staticRenderFns } from "./consent-collection-widget-position-and-trigger-step.vue?vue&type=template&id=1f332a36"
import script from "./consent-collection-widget-position-and-trigger-step.vue?vue&type=script&lang=js"
export * from "./consent-collection-widget-position-and-trigger-step.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports